module.exports = __webpack_public_path__ + "static/media/features-split-icon.09ab6a6d.svg";